import React, { useState } from 'react';
import Bouton from '../../../UI/Bouton/Bouton';
import styles from '../ProfilProjet.module.scss';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import ImporterImage from '../../../UI/ImporterImage/ImporterImage';
import { checkMot } from '../../../../ressources/functionJS/checkMot';

const AjouterImageProjet = ({ project_id, ajouterImageProjet }) => {
  const [imageImporter, setImageImporter] = useState(null);

  const gererImageImporter = (newImage) => {
    setImageImporter(newImage);
  };

  const boutonEnvoi =
    imageImporter !== null ? (
      <Bouton
        ajoutClass={styles.btn_enre}
        cliquer={() => ajouterImageProjet(project_id, imageImporter.base64)}
      >
        {checkMot('enregistrer_l_image')}
      </Bouton>
    ) : (
      <Bouton ajoutClass={styles.btn_enre} desactive={true}>
        {checkMot('enregistrer_l_image')}
      </Bouton>
    );

  return (
    <>
      <div className={[styles.modalCorp, styles.text_style, s.row].join(' ')}>
        <div
          className={[styles.modalCorp, styles.text_style, s.col_12].join(' ')}
        >
          <ImporterImage
            extensionAccepter={'.jpg'}
            gererImageImporter={gererImageImporter}
          />
        </div>
        <div className={[s.text_left, s.col_sm_6, styles.text_style].join(' ')}>
          <AttenteRequete
            request_type={requestType.ajouter_une_image_de_projet}
          >
            {boutonEnvoi}
          </AttenteRequete>
        </div>
      </div>
    </>
  );
};

export default AjouterImageProjet;
